export const SOFTLINE_PERMISSION_PRODUKTKALKULATION = 'Produktkalkulation';

export const SOFTLINE_FEATURE_PRODUKTKALKULATION = 'produktkalkulation';
